export const contractTypes = [
  { label: 'Posrednik', value: 'UIR' },
  { label: 'Organizator', value: 'VIR' },
];

export enum EContractTypes {
  UIR = 'UIR',
  'Odaberi...' = -1,
}

export const accountTypes = [
  { label: 'Odaberi...', value: -1 },
  { label: 'Posebni postupak oporezivanja', value: 'PP' },
  { label: 'Redovni račun', value: 'RR' },
];

export const collaborationType = [
  { label: 'Odaberi...', value: -1 },
  { label: 'VIP', value: 'VIP' },
  { label: 'FIX', value: 'FIX' },
  { label: 'VIP i FIX', value: 'VFX' },
  { label: 'MINUS ', value: 'MNS' },
];

export const fixedCancellationCosts = [{ label: 'Fiksni storno troškovi', value: 0 }];

export enum ESignatureType {
  Physical = 'Physical ',
  Online = 'Online',
}

export const documentType = [
  { label: 'Kategorizacija', value: 'KAT' },
  { label: 'Cjenik', value: 'CJE' },
  { label: 'Ugovor', value: 'UGO' },
  { label: 'Prekid suradnje', value: 'PRS' },
  { label: 'Ostalo', value: 'OST' },
];

export const imageExtensions = ['jpg', 'jpeg', 'png', 'svg', 'gif', 'doc'];

export const vendorDocExtensions = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];

export enum EImageExtensions {
  jpg = 'jpg',
  jpeg = 'jpeg',
  png = 'png',
  svg = 'svg',
  gif = 'gif',
}

export enum EDocumentExtensions {
  pdf = 'pdf',
  pptx = 'pptx',
  ppt = 'ppt',
  xlsx = 'xlsx',
  xls = 'xls',
  docx = 'docx',
  doc = 'doc',
}
